import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { thanksgivingPromo, isPromoActive } from '../data/promo';
import { PromoCountdown } from './PromoCountdown';
import { ArrowRightIcon, PlusIcon } from './icons';
const ease = [0.23, 1, 0.32, 1] as const;
const STORAGE_KEY = `promo-bar-dismissed-${thanksgivingPromo.id}`;
export function PromoBar() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (!isPromoActive()) return;
    try {
      if (window.sessionStorage.getItem(STORAGE_KEY) === '1') return;
    } catch {
      // Storage unavailable — show the bar anyway.
    }
    setVisible(true);
  }, []);
  const dismiss = () => {
    setVisible(false);
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Ignore storage errors.
    }
  };
  return <AnimatePresence initial={false} data-id="element-546" data-mp="19yiz39alpppy">
      {visible && <motion.aside aria-label={thanksgivingPromo.occasion} initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease
    }} className="relative w-full overflow-hidden bg-gold text-ink" data-id="element-547" data-mp="d65tdbwfrtix">
          <div className="mx-auto flex max-w-content flex-col gap-3 px-5 py-3.5 lg:flex-row lg:items-center lg:gap-6 lg:px-8" data-id="element-548" data-mp="88494nn9xo5v">
            <div className="flex min-w-0 flex-1 items-center gap-3.5" data-id="element-549" data-mp="vxfekifkk6qc">
              <motion.span animate={reduceMotion ? undefined : {
            scale: [1, 1.06, 1]
          }} transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="flex shrink-0 flex-col items-center justify-center rounded-md bg-ember px-3 py-2 text-center text-white" data-id="element-550" data-mp="10up21sjee8bj">
                <span className="font-banner text-[10px] font-extrabold uppercase leading-none tracking-[0.18em]" data-id="element-551" data-mp="1etezxae1kc0y">
                  Thanksgiving
                </span>
                <span className="mt-1 font-banner text-xl font-black uppercase leading-none" data-id="element-552" data-mp="1tgx84iqtbos4">
                  Free
                </span>
              </motion.span>
              <p className="min-w-0" data-id="element-553" data-mp="1kh0nqtbghc2v">
                <span className="block font-banner text-base font-black uppercase leading-tight tracking-tight sm:text-xl" data-id="element-554" data-mp="1kfyzfn5fit37">
                  {thanksgivingPromo.headline}
                </span>
                <span className="mt-0.5 block text-[13px] font-semibold text-ink/75 sm:text-sm" data-id="element-555" data-mp="1ak4cwgy34dv5">
                  Included free {thanksgivingPromo.condition} booked by November 30.
                </span>
              </p>
            </div>

            <div className="flex items-center justify-between gap-4 lg:justify-end" data-id="element-556" data-mp="10r6t87hcwiuy">
              <div className="flex items-center gap-2.5" data-id="element-557" data-mp="wpuyxonjf9gf">
                <span className="hidden text-[11px] font-bold uppercase leading-tight tracking-wide text-ink/70 sm:block" data-id="element-558" data-mp="rrtfv3q43a4y">
                  Ends in
                </span>
                <PromoCountdown data-id="element-559" data-mp="2yhdh56qkxc0l" />
              </div>
              <a href="#contact" onClick={dismiss} className="inline-flex shrink-0 items-center gap-2 rounded-md bg-ink px-4 py-2.5 font-banner text-[13px] font-black uppercase tracking-wide text-gold transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-navy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink sm:text-sm" data-id="element-560" data-mp="2ygvftvp287lt">
                Claim it
                <ArrowRightIcon className="h-4 w-4" data-id="element-561" data-mp="2knm9y50bm481" />
              </a>
            </div>
          </div>

          <button type="button" onClick={dismiss} aria-label="Dismiss Thanksgiving promotion" className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full text-ink/60 transition-colors duration-150 ease-out hover:bg-ink/10 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink" data-id="element-562" data-mp="2op7ije5tnwcf">
            <PlusIcon className="h-4 w-4 rotate-45" data-id="element-563" data-mp="1hv0awtbfr66i" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}